import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Game1024 from '../../components/games/Game1024';
import GameSnake from '../../components/games/GameSnake';
import Tetris from '../../components/games/Tetris';
import SheepGame from '../../components/games/SheepGame';
import './index.scss';
import '../../styles/menu.scss';
import '../../styles/container.scss';

const gameMenus = [
  { label: '1024', path: 'game1024' },
  { label: '贪吃蛇', path: 'snake' },
  { label: '俄罗斯方块', path: 'tetris' },
  { label: '羊了个羊', path: 'sheep' },
];

export default function Game() {
  const navigate = useNavigate();
  const location = useLocation();
  const activePath = location.pathname.split('/')[2] || gameMenus[0].path;
  const activeMenu = gameMenus.find(m => m.path === activePath) || gameMenus[0];

  // 方向操作按钮处理函数
  const handleDirectionControl = (action) => {
    // 根据当前游戏类型发送相应的操作
    const event = new CustomEvent('gameControl', { 
      detail: { action, gameType: activePath } 
    });
    window.dispatchEvent(event);
  };

  // 渲染游戏内容
  const renderGameContent = () => {
    switch (activeMenu.path) {
      case 'game1024':
        return <Game1024 />;
      case 'snake':
        return <GameSnake />;
      case 'tetris':
        return <Tetris />;
      case 'sheep':
        return <SheepGame />;
      default:
        return <div className="page_content_placeholder">这里是「{activeMenu.label}」的内容区域。</div>;
    }
  };

  return (
    <div className="page_container">
      {/* 左侧菜单栏 */}
      <div className="menu_sidebar">
        {gameMenus.map(menu => (
          <div
            key={menu.path}
            onClick={() => navigate(`/game/${menu.path}`)}
            className={`menu_item ${activePath === menu.path ? 'menu_item_active' : ''}`}
          >
            {menu.label}
          </div>
        ))}
      </div>
      {/* 右侧内容区 */}
      <div className="page_content_area">
        {renderGameContent()}
      </div>
    </div>
  );
} 